export default __webpack_public_path__ + "static/ak-cached/24h/media/seamless_header-move.588636a8.jpg";